const svgProps = { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512' }

const IcoChinese = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='-49 141 512 512'>
    <circle fill='#D80027' cx='207' cy='397' r='256' />
    <polygon
      fill='#FFDA44'
      points='91.1,296.8 113.2,364.8 184.7,364.8 126.9,406.9 149,474.9 91.1,432.9 33.2,474.9 55.4,406.9 -2.5,364.8 69,364.8 	'
    />
    <polygon
      fill='#FFDA44'
      points='254.5,537.5 237.6,516.7 212.6,526.4 227.1,503.9 210.2,483 236.1,489.9 250.7,467.4 252.1,494.2 278.1,501.1 253,510.7'
    />
    <polygon
      fill='#FFDA44'
      points='288.1,476.5 296.1,450.9 274.2,435.4 301,435 308.9,409.4 317.6,434.8 344.4,434.5 322.9,450.5 331.5,475.9 309.6,460.4'
    />
    <polygon
      fill='#FFDA44'
      points='333.4,328.9 321.6,353 340.8,371.7 314.3,367.9 302.5,391.9 297.9,365.5 271.3,361.7 295.1,349.2 290.5,322.7 309.7,341.4'
    />
    <polygon
      fill='#FFDA44'
      points='255.2,255.9 253.2,282.6 278.1,292.7 252,299.1 250.1,325.9 236,303.1 209.9,309.5 227.2,289 213,266.3 237.9,276.4'
    />
  </svg>
)

const IcoEnglish = () => (
  <svg {...svgProps}>
    <circle fill='#F0F0F0' cx='256' cy='256' r='256' />
    <path fill='#0052B4' d='M52.92,100.142c-20.109,26.163-35.272,56.318-44.101,89.077h133.178L52.92,100.142z' />
    <path fill='#0052B4' d='M503.181,189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075,89.076H503.181z' />
    <path
      fill='#0052B4'
      d='M8.819,322.784c8.83,32.758,23.993,62.913,44.101,89.075l89.074-89.075L8.819,322.784L8.819,322.784	z'
    />
    <path fill='#0052B4' d='M411.858,52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177L411.858,52.921z' />
    <path fill='#0052B4' d='M100.142,459.079c26.163,20.109,56.318,35.272,89.076,44.102V370.005L100.142,459.079z' />
    <path fill='#0052B4' d='M189.217,8.819c-32.758,8.83-62.913,23.993-89.075,44.101l89.075,89.075V8.819z' />
    <path fill='#0052B4' d='M322.783,503.181c32.758-8.83,62.913-23.993,89.075-44.101l-89.075-89.075V503.181z' />
    <path fill='#0052B4' d='M370.005,322.784l89.075,89.076c20.108-26.162,35.272-56.318,44.101-89.076H370.005z' />
    <path
      fill='#D80027'
      d='M509.833,222.609h-220.44h-0.001V2.167C278.461,0.744,267.317,0,256,0
		c-11.319,0-22.461,0.744-33.391,2.167v220.44v0.001H2.167C0.744,233.539,0,244.683,0,256c0,11.319,0.744,22.461,2.167,33.391
		h220.44h0.001v220.442C233.539,511.256,244.681,512,256,512c11.317,0,22.461-0.743,33.391-2.167v-220.44v-0.001h220.442
		C511.256,278.461,512,267.319,512,256C512,244.683,511.256,233.539,509.833,222.609z'
    />
    <path
      fill='#D80027'
      d='M322.783,322.784L322.783,322.784L437.019,437.02c5.254-5.252,10.266-10.743,15.048-16.435 l-97.802-97.802h-31.482V322.784z'
    />
    <path
      fill='#D80027'
      d='M189.217,322.784h-0.002L74.98,437.019c5.252,5.254,10.743,10.266,16.435,15.048l97.802-97.804 V322.784z'
    />
    <path
      fill='#D80027'
      d='M189.217,189.219v-0.002L74.981,74.98c-5.254,5.252-10.266,10.743-15.048,16.435l97.803,97.803 H189.217z'
    />
    <path
      fill='#D80027'
      d='M322.783,189.219L322.783,189.219L437.02,74.981c-5.252-5.254-10.743-10.266-16.435-15.047 l-97.802,97.803V189.219z'
    />
  </svg>
)

const IcoGerman = () => (
  <svg viewBox='0 0 300 300' width='300' height='300'>
    <defs>
      <clipPath id='myClip'>
        <circle cx='150' cy='150' r='150' />
      </clipPath>
    </defs>
    <rect width='300' height='100' fill='#000000' clipPath='url(#myClip)' />
    <rect width='300' height='100' fill='#D80027' clipPath='url(#myClip)' y='100' />
    <rect width='300' height='100' fill='#FFDA44' clipPath='url(#myClip)' y='200' />
  </svg>
)

const IcoItalian = () => (
  <svg viewBox='0 0 300 300' width='300' height='300'>
    <defs>
      <clipPath id='myClip'>
        <circle cx='150' cy='150' r='150' />
      </clipPath>
    </defs>
    <rect width='100' height='300' fill='#d80027' clipPath='url(#myClip)' x='200' />
    <rect width='100' height='300' fill='#ffffff' clipPath='url(#myClip)' x='100' />
    <rect width='100' height='300' fill='#6da544' clipPath='url(#myClip)' />
  </svg>
)

const IcoRussian = () => (
  <svg viewBox='0 0 300 300' width='300' height='300'>
    <defs>
      <clipPath id='myClip'>
        <circle cx='150' cy='150' r='150' />
      </clipPath>
    </defs>
    <rect width='300' height='100' fill='#f0f0f0' clipPath='url(#myClip)' />
    <rect width='300' height='100' fill='#0052B4' clipPath='url(#myClip)' y='100' />
    <rect width='300' height='100' fill='#D80027' clipPath='url(#myClip)' y='200' />
  </svg>
)

const IcoSpanish = () => (
  <svg viewBox='0 0 300 300' width='300' height='300'>
    <defs>
      <clipPath id='myClip'>
        <circle cx='150' cy='150' r='150' />
      </clipPath>
    </defs>
    <rect width='100' height='300' fill='#d80027' clipPath='url(#myClip)' x='200' />
    <rect width='100' height='300' fill='#ffffff' clipPath='url(#myClip)' x='100' />
    <rect width='100' height='300' fill='#6da544' clipPath='url(#myClip)' />
  </svg>
)

const IcoWorld = () => (
  <svg {...svgProps}>
    <circle fill='#0052B4' cx='256' cy='256' r='256' />
    <polygon
      fill='#FFDA44'
      points='256.001,100.174 264.29,125.683 291.11,125.683 269.411,141.448 277.7,166.957 256.001,151.191 234.301,166.957 242.59,141.448 220.891,125.683 247.712,125.683'
    />
    <polygon
      fill='#FFDA44'
      points='145.814,145.814 169.714,157.99 188.679,139.026 184.482,165.516 208.381,177.693 181.89,181.889 177.694,208.381 165.517,184.482 139.027,188.679 157.992,169.714'
    />
    <polygon
      fill='#FFDA44'
      points='100.175,256 125.684,247.711 125.684,220.89 141.448,242.59 166.958,234.301 151.191,256 166.958,277.699 141.448,269.411 125.684,291.11 125.684,264.289'
    />
    <polygon
      fill='#FFDA44'
      points='145.814,366.186 157.991,342.286 139.027,323.321 165.518,327.519 177.693,303.62 181.89,330.111 208.38,334.307 184.484,346.484 188.679,372.974 169.714,354.009'
    />
    <polygon
      fill='#FFDA44'
      points='256.001,411.826 247.711,386.317 220.891,386.317 242.591,370.552 234.301,345.045 256.001,360.809 277.7,345.045 269.411,370.552 291.11,386.317 264.289,386.317'
    />
    <polygon
      fill='#FFDA44'
      points='366.187,366.186 342.288,354.01 323.322,372.975 327.519,346.483 303.622,334.307 330.112,330.111 334.308,303.62 346.484,327.519 372.974,323.321 354.009,342.288'
    />
    <polygon
      fill='#FFDA44'
      points='411.826,256 386.317,264.289 386.317,291.11 370.552,269.41 345.045,277.699 360.81,256 345.045,234.301 370.553,242.59 386.317,220.89 386.317,247.712'
    />
    <polygon
      fill='#FFDA44'
      points='366.187,145.814 354.01,169.714 372.975,188.679 346.483,184.481 334.308,208.38 330.112,181.889 303.622,177.692 327.519,165.516 323.322,139.027 342.289,157.991'
    />
  </svg>
)

const IcoTest = () => (
  <svg viewBox='0 0 300 300' width='300' height='300'>
    <defs>
      <clipPath id='myClip'>
        <circle cx='150' cy='150' r='150' />
      </clipPath>
      <polygon
        id='star'
        points='
        150 125, 159 152,
         182 150, 162 167,
          172 192, 150 175,
          128 192, 138 167,
          118 150, 141 152'
        fill='#FFDA44'
      />
    </defs>
    <rect width='300' height='100' fill='#000000' clipPath='url(#myClip)' />
    {/* <rect width='300' height='100' fill='#FFDA44' clipPath='url(#myClip)' y='100' /> */}
    <rect width='300' height='100' fill='#D80027' clipPath='url(#myClip)' y='200' />
    <use xlinkHref='#star' fill='#FFDA44' />
    {/* 
      <g transform='matrix(1, 0, 0, 1, -0.0009, 7.499601)'></g>
      <g transform='matrix(0, 1, -1, 0, 292.500397, -0.0009)'></g>
      <g transform='matrix(-0.707107, 0.707107, -0.707107, -0.707107, 356.829651, 144.69635)'></g> 
    */}
  </svg>
)

type IconArrayType = {
  [key: string]: JSX.Element
}

const iconArray: IconArrayType = {
  chinese: <IcoChinese />,
  english: <IcoEnglish />,
  german: <IcoGerman />,
  italian: <IcoItalian />,
  russian: <IcoRussian />,
  spanish: <IcoSpanish />,
  world: <IcoWorld />,
  test: <IcoTest />,
}
export default iconArray
